import axios from "axios";
import API_CONFIG from "../../config/api";

const base = API_CONFIG.API_URL;
const unwrap = (response) => response?.data || {};

export async function fetchLogisticsShipments({ companyId, page = 1, limit = 20, ...filters }) {
  const data = unwrap(await axios.get(`${base}/logistics/shipments`, {
    params: { company_id: companyId, page, limit, ...filters },
  }));
  return {
    rows: data.success ? data.data || [] : [],
    pagination: data.pagination || { page, limit, total: 0, total_pages: 0 },
  };
}

export async function fetchLogisticsShipment(id) {
  const data = unwrap(await axios.get(`${base}/logistics/shipments/${id}`));
  return data.success ? data.data : null;
}

export async function saveLogisticsShipment(id, payload) {
  const response = id
    ? await axios.put(`${base}/logistics/shipments/${id}`, payload)
    : await axios.post(`${base}/logistics/shipments`, payload);
  return unwrap(response);
}

export async function deleteLogisticsShipment(id, companyId) {
  return axios.delete(`${base}/logistics/shipments/${id}`, { params: { company_id: companyId } });
}

export async function fetchLogisticsTreasuryFlows(params) {
  const data = unwrap(await axios.get(`${base}/logistics/treasury`, { params }));
  return {
    rows: data.success ? data.data || [] : [],
    total: Number(data.pagination?.total || 0),
  };
}

export async function fetchLogisticsTreasuryTotals(params) {
  const data = unwrap(await axios.get(`${base}/logistics/treasury/totals`, { params }));
  const totals = data.success ? data.data || {} : {};
  return {
    incoming: Number(totals.total_incoming || 0),
    outgoing: Number(totals.total_outgoing || 0),
    count: Number(totals.total_count || 0),
    currency: totals.currency_symbol || "F",
    currencyCount: Number(totals.currency_count || 0),
  };
}
